import React, {useState} from 'react'
import {AutoPaySettings, PaymentAccount} from '../../types/app-types'
import PaymentAccountListItem from './PaymentAccountListItem'
import AutoPayPolicyModal from './AutoPayPolicyModal'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faCircleInfo} from '@fortawesome/free-solid-svg-icons'

export interface PaymentAccountListProps {
  paymentAccounts: PaymentAccount[]
  autoPayAccount: PaymentAccount
  autoPaySettings: AutoPaySettings
  onAddPaymentAccount: () => void
  onRemovePaymentAccount: (paymentAccount: PaymentAccount) => void
  onEditAutoPay: (paymentAccount: PaymentAccount) => void
  onEnableAutoPay: (paymentAccount: PaymentAccount) => void
  onDisableAutoPay: (paymentAccount: PaymentAccount) => void
}

const PaymentAccountList = (props: PaymentAccountListProps) => {
  const {
    paymentAccounts,
    autoPayAccount,
    autoPaySettings,
    onAddPaymentAccount,
    onRemovePaymentAccount,
    onEditAutoPay,
    onEnableAutoPay,
    onDisableAutoPay
  } = props

  // modal states and account selection
  const [policyModalOpen, setPolicyModalOpen] = useState(false)

  return (
    <div>
      <div className="mt-4 mb-8 flex flex-row">
        <div className="grow w-full">
          <button
            className="btn btn-primary"
            onClick={e => onAddPaymentAccount()}
          >
            Add Payment Account
          </button>
        </div>
        <div className="w-60 text-sm flex flex-col justify-center">
          <a className="link" onClick={() => setPolicyModalOpen(true)}>
            <FontAwesomeIcon icon={faCircleInfo} className="mr-2" />
            Terms and Conditions
          </a>
        </div>
      </div>
      <div className="flex flex-col gap-2 mt-6">
        {paymentAccounts.map(paymentAccount => {
          const isAutoPayAccount = paymentAccount === autoPayAccount
          return (
            <PaymentAccountListItem
              key={paymentAccount.id}
              isAutoPayAccount={isAutoPayAccount}
              autoPaySettings={autoPaySettings}
              paymentAccount={paymentAccount}
              onRemovePaymentAccount={onRemovePaymentAccount}
              onEditAutoPay={onEditAutoPay}
              onEnableAutoPay={onEnableAutoPay}
              onDisableAutoPay={onDisableAutoPay}
            />
          )
        })}
      </div>
      <AutoPayPolicyModal
        isOpen={policyModalOpen}
        onClose={() => setPolicyModalOpen(false)}
      />
    </div>
  )
}

export default PaymentAccountList
